<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button [mat-dialog-close]="true">Confirm</button>
  <button mat-stroked-button [mat-dialog-close]="false" cdkFocusInitial>
    Cancel
  </button>
</div>
